import React from 'react';
import './RenewalsPageInfo.scss';
import { useTranslation } from 'react-i18next';

export type JustSoYouKnowProps = {
  text: string;
};

const JustSoYouKnow = ({ text }: JustSoYouKnowProps): JSX.Element => {
  const { t } = useTranslation();
  const justSoYouKnowHeading = t('landing-page.just-so-you-know-heading');
  return (
    <div>
      <div className='info m05-bottom'>
        <p className='p1-bold m05-bottom'>{justSoYouKnowHeading}</p>
        <p className='p3 m05-bottom cms'>{text}</p>
      </div>
      <hr />
    </div>
  );
};

export default JustSoYouKnow;
